import React from 'react';
import SEO from '../components/SEO';

const NotFoundPage = () => (
  <>
    <SEO title="404 Not Found" noIndex={true} />
    <div style={{padding:'2rem',textAlign:'center'}}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  </>
);

export default NotFoundPage;
